var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isInApp)?_c('div',{class:{'back-wash': _vm.hasHeight}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }